const EVENTS = {
	CHAT: {
		READY: 'chat:ready',
		INITIAL_ROOM_FETCH: 'chat:initial-room-fetch',
		MESSAGE: {
			CREATE: 'chat:message:create',
			DELETE: 'chat:message:delete',
			UPDATE: 'chat:message:update',
		},
		ROOM: {
			NEW: 'chat:room:new',
		},
	},
};

export default EVENTS;
